export default __webpack_public_path__ + "static/media/delta-arrow.a896397f.svg";